import { Injectable } from '@angular/core';
import { RoleService } from '../roles/services/role.service';
import { MojoWellKnownNames } from "../common/constants/mojo-well-known-names";
import { PmaPermissionsService } from '../roles/services/pma-permissions.service';
import { UserSettingsService } from '@feature/user-settings/services/user-settings.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs';
import {UserSettings} from "@feature/user-settings";

//** Used to provide permissions for the current user  */
@Injectable()
export class UserPermissionsService {

  constructor(private roleService: RoleService,
    private pmaPermissionsService: PmaPermissionsService,
    private userSettingsService: UserSettingsService) { }

  private getPermissions(): string[] {
    const userSettings = this.userSettingsService.getUserSettingsImmediate();
    return  userSettings ? userSettings.Permissions : [];
  }

  private isPreviewer(): boolean {
    return this.roleService.isInRole(MojoWellKnownNames.RoleNames.Previewer);
  }

  public isFormsAdministrator(): boolean {
    return this.pmaPermissionsService.hasPermission(MojoWellKnownNames.PmaPermissions.FormsAdministrator);
  }

  private isSystemAdmin(): boolean {
    return this.roleService.isInRole(MojoWellKnownNames.RoleNames.SystemAdministrator);
  }

  private isClientAdmin(): boolean {
    return this.roleService.isInRole(MojoWellKnownNames.RoleNames.ClientAdministrator);
  }

  canPreview(): boolean {
    return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.PreviewProducts) > -1;
  }

  canAdministerUsers(): boolean {
    return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.AdministerUsers) > -1;
  }

  canConfigureSystem(): boolean {
    return this.isSystemAdmin();
  }

  canAdministerWidgets(): boolean {
    return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.AdministerWidgets) > -1;
  }

  canConfigureProfilesAndDashboards(): boolean {
    return this.isSystemAdmin();
  }

  canConfigureClientsAndClientParents(): boolean {
    return this.isSystemAdmin();
  }

  canConfigureFaqs(): boolean {
    return this.isSystemAdmin();
  }

  canSeeAdminOverview(): boolean {
    return this.isSystemAdmin();
  }

  userHasUploadDocumentsPermission(userSettings: UserSettings): boolean {
    return userSettings.Permissions.indexOf(MojoWellKnownNames.PermissionNames.UploadDocuments) > -1;
  }

  canUploadDocumentCentreDocuments(): Observable<boolean> {
    return this.userSettingsService.getUserSettings()
      .pipe(map(this.userHasUploadDocumentsPermission));
  }

  canEditDocumentCentreMetadata(): boolean {
    return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.EditDocumentCenterMetaData) > -1;
  }


  canDeletePropertyPictures(): Observable<boolean> {
    return  this.userSettingsService.getCurrentProduct().pipe(
      take(1),
      map(product => {
        return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.UploadPropertyPictures) > -1 &&
         product!= MojoWellKnownNames.Platforms.Mci;
      })
    );
  }

  canUploadPropertyPictures(): boolean {
    return this.getPermissions().indexOf(MojoWellKnownNames.PermissionNames.UploadPropertyPictures) > -1;
  }
}
